<template>
    <div>
      <!-- ページヘッダー -->
      <div class="container-fluid page-head-wrap">
        <div class="container page-head">
          <h3 class="h4 text-center">
            <b><trans-text i18nKey="ui[15][1]"/></b>
          </h3>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="offset-md-2 col-md-8 px-md-5">
            <!-- 入力フォーム -->

            <div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">
              <b><trans-text :i18nKey="apiErrorI18nKey"/></b>
            </div>

            <div class="form-wrap">
              <div class="form-list py-3">

                <!-- 入力項目-->
                <div class="form-group row" :class="{'has-danger': $v.input.password.$error}">
                  <label class="col-5 col-form-label"><trans-text i18nKey="ui[15][4]"/></label>
                  <div class="col-7">
                    <input class="form-control transparent-input" type="password" value="" placeholder="********" v-model.trim="input.password" @change="$v.input.password.$touch()">
                  </div>
                  <p class="col-12 pl-4 my-0 form-control-feedback">
                    <input-feedback :validate-for-input="$v.input.password" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[15][1]"/></input-feedback>
                  </p>
                  <div class="col-12 form-hr">
                    <hr class="">
                  </div>
                </div>

                <!-- フォーム送信UI -->
                <div class="row text-center">
                  <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
                    <div class="my-2">
                      <!--<button type="button" class="btn w-100 btn-lg btn-warning" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[13][8]"/></button>-->
                      <button type="button" class="btn w-100 btn-lg btn-warning" @click="tryForm"><trans-text i18nKey="ui[15][5]"/></button>
                    </div>
                  </div>
                </div>
                <div class="row text-center">
                  <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
                    <div class="my-2">
                      <router-link tag="button" class="btn w-100 btn-lg btn-default" :to="{ name: 'password-remind-from', params:{} }">
                        <trans-text i18nKey="ui[15][6]"/>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    name:"PasswordRemindVerify",
    components: {
    },
    data () {
      return {
        apiErrorI18nKey:null,
        input: {
          password: "",
          hash:"",
        }

      }
    },
    validations: {
      input: {
        password: {
          required,
        },
      },
    },
    created(){
    },
    methods:{
      tryForm(){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }

        this.input.hash = this.$route.query.hash
        app.make("axios").post(`v1/password-verify`,this.input)
          .then(({data}) =>{
            this.$router.push({name:"password-remind-complete"})
          })
          .catch(error => {
            this.apiErrorI18nKey = "error[15][2]"
          })


      },
    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// PasswordRemindVerify.vue?0ef67106